import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Menu from 'components/Menu';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from 'components/Grid';

import { TableColumn } from 'components/NewTable/type';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';

import { isType, isTypeBK, localeTw, userTypeList } from 'main_consts';
import { Iobject, Ioption } from 'main_type';
import {
  blobDownload,
  getSample,
  postSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  postExcel,
  postExcelAndFunctionName,
  getImgSrc,
} from 'main_api';

import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Select from 'components/Material/Select';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import {
  checkboxChange,
  formatDate,
  getDateDayPlus,
  getFindDropDownList,
  getWarehouse,
  initWhrehhouse,
  inputChange,
  selectChange,
} from '../../../main_func';

import { Iresult, Imaster, ICRUDDetail, ICRUD } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 暫存貨物查詢維護 */
const TmpStorageGoodsMtn = (): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const { enqueueSnackbar } = useSnackbar();

  const masterDefaultValue: Imaster = {
    // 儲區名稱
    expresssId: '',
    goodsType: '',
    storageAreaId: '',
    hawbNo: '',
    processCustoms: '',
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',
    // 入儲時間_開始
    startUpdtime: getDateDayPlus(),
    startTime: '000000',
    // 入儲時間_結束
    endUpdtime: getDateDayPlus(),
    endTime: '235959',
    startUpdtimeValid: true,
    endUpdtimeValid: true,
    timeCheck: '0',
    imageFileName: '',

    defMawbNo: false,
    releaseDateIsNull: false,
    pageSize: 100,
  };
  const [master, setMaster] = useState(masterDefaultValue);

  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'tmpStorageGoodsMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');

  const [storageAreaOptions, setStorageAreaOptions] = useState<Ioption[]>([]);
  const [goodsTypeOptions, setGoodsTypeOptions] = useState<Ioption[]>([]);
  const [enableSave, setEnableSave] = useState<boolean>(false);

  const [random, setRamdom] = useState(Math.random());

  const setDropDownList = () => {
    if (master.warehouse) {
      getFindDropDownList('findDropDownStorageArea', {
        warehouse: master.warehouse,
      }).then((item) => {
        setStorageAreaOptions(item);
      });
      getFindDropDownList('findDropDownGoodsType', {
        warehouse: master.warehouse,
      }).then((item) => {
        setGoodsTypeOptions(item);
      });
    }
  };
  useEffect(() => {
    setDropDownList();
  }, [master.warehouse]);

  useEffect(() => {
    setDropDownList();
    if (
      userType &&
      !(
        isType(userTypeList.admin, userType) ||
        isType(userTypeList.type1, userType) ||
        isType(userTypeList.type2, userType) ||
        isType(userTypeList.type4, userType) ||
        isType(userTypeList.type6, userType) ||
        isType(userTypeList.topType, userType) ||
        isTypeBK(userType)
      )
    ) {
      setFormError(true);
      enqueueSnackbar(`您無權限使用此功能!`);
    }
    setMaster((prev) => ({
      ...prev,
      warehouse: masterDefaultValue.warehouse,
    }));
  }, [userType]);

  const MedalCellRenderer = ({
    value,
    data,
    colDef,
    ...other
  }: any): HTMLElement => {
    // console.log('MedalCellRendererByHwb(data): ', data);
    // console.log('MedalCellRendererByHwb(other): ', other);
    // console.log('MedalCellRendererByHwb(colDef): ', colDef);
    const fileImageNmae =
      colDef.field === 'hwbImageBase64File'
        ? data.hwbImageFile
        : data.goodsImageFile;
    if (fileImageNmae) {
      const buttonSrc = document.createElement('button');
      buttonSrc.setAttribute('button', value);
      buttonSrc.innerText = '圖檔';
      buttonSrc.setAttribute(
        'style',
        'width: auto; height: auto; padding: 6px 20px;'
      );

      buttonSrc.onclick = async () => {
        const result = await getImgSrc(apiName, {
          warehouse: data.warehouse,
          storageAreaId: data.storageAreaId,
          imageFileName: fileImageNmae,
        });

        const strImage = result.data.data as string;
        if (!strImage || strImage.length > 0) {
          const newWindow = window.open('', '', 'width=500,height=500');
          if (newWindow) {
            const dialog = newWindow.document.createElement('dialog');
            dialog.setAttribute('open', 'true');
            dialog.addEventListener('close', () => newWindow.close());
            const img = newWindow.document.createElement('img');
            img.setAttribute('src', strImage);

            dialog.appendChild(img);
            newWindow.document.body.appendChild(dialog);
          }
        }
      };

      return buttonSrc;
    }
    return document.createElement('div');
  };

  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '儲區',
        field: 'storageAreaDesc',
        width: 300,
      },
      {
        headerName: '儲位',
        field: 'locationDesc',
        width: 300,
        editable: true,
      },
      {
        headerName: '分類',
        field: 'goodsType',
        width: 300,
      },
      {
        headerName: '分號',
        field: 'hawbNo',
        width: 300,
      },
      {
        headerName: '主號',
        field: 'mawbNo',
        width: 300,
      },
      {
        headerName: '報單號碼',
        field: 'lastdeclNo',
        width: 300,
      },
      {
        headerName: '快遞/承攬業',
        field: 'expressCnam',
        width: 300,
      },
      {
        headerName: '報關業',
        field: 'boxNo',
        width: 300,
      },
      {
        headerName: '申報件數',
        field: 'declPiece',
        width: 300,
      },
      {
        headerName: '移入件數',
        field: 'storagePiece',
        width: 300,
      },
      {
        headerName: '長(單位CM)',
        field: 'length',
        width: 300,
      },
      {
        headerName: '寬(單位CM)',
        field: 'width',
        width: 300,
      },
      {
        headerName: '高(單位CM)',
        field: 'height',
        width: 300,
      },
      {
        headerName: '材積(單位CBM)',
        field: 'volume',
        width: 300,
      },
      {
        headerName: '重量(單位KG)',
        field: 'weight',
        width: 300,
      },
      {
        headerName: '放行日期',
        field: 'releaseDateDesc',
        width: 300,
        editable: true,
      },
      {
        headerName: '貨物分號標籤圖檔',
        field: 'hwbImageBase64File',
        width: 300,

        cellRenderer: MedalCellRenderer,
      },
      {
        headerName: '貨物整體圖檔 ',
        field: 'goodsImageBase64File',
        width: 300,
        cellRenderer: MedalCellRenderer,
      },
      {
        headerName: '承辦關員',
        field: 'processCustoms',
        width: 300,
      },
      {
        headerName: '貨名',
        field: 'goodsDesc',
        width: 300,
      },
      {
        headerName: '入儲時間',
        field: 'updtime',
        width: 300,
      },
      {
        headerName: '進倉時間',
        field: 'gcidate',
        width: 300,
      },
      {
        headerName: '備註',
        field: 'remark',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          if (params && params.data.processDesc === '寫檔成功!') {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    const result = await postSearch(apiName, {
      warehouse: master.warehouse,
      goodsType: master.goodsType,
      storageAreaId: master.storageAreaId,
      hawbNo: master.hawbNo,
      processCustoms: master.processCustoms,
      expresssId: master.chkCode1,
      startUpdtime:
        master.timeCheck === '1' ? master.startUpdtime + master.startTime : '',
      endUpdtime:
        master.timeCheck === '1' ? master.endUpdtime + master.endTime : '',
      defMawbNo: master.defMawbNo,
      releaseDateIsNull: master.releaseDateIsNull,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }

    // TODO 確認List名稱
    const { data: dataTemp } = result.data;
    const {
      enableSave: enableSaveTemp,
      tmpStorageGoodsMtnGoodsPositions: rowDetailsTemp,
    } =
      (dataTemp as {
        enableSave: boolean;
        tmpStorageGoodsMtnGoodsPositions: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];
    if (data && (data || []).length > 0) {
      setEnableSave(enableSaveTemp);
      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    await gridRef.current.api.stopEditing(false);

    const rowDataCRUD: ICRUDDetail[] = [];

    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      selectedDatas.forEach((node: any) => {
        const itemDataCRUD: ICRUDDetail = {
          rownum: node.data.rownum,
          storageAreaId: node.data.storageAreaId,
          warehouse: node.data.warehouse,
          storageAreaDesc: node.data.storageAreaDesc,
          locationDesc: node.data.locationDesc,
          hawbNo: node.data.hawbNo,
          mawbNo: node.data.mawbNo,
          lastdeclNo: node.data.lastdeclNo,
          expressCnam: node.data.expressCnam,
          boxNo: node.data.boxNo,
          storagePiece: node.data.storagePiece,
          length: node.data.length,
          width: node.data.width,
          height: node.data.height,
          volume: node.data.volume,
          weight: node.data.weight,
          releaseDateDesc: node.data.releaseDateDesc,
          hwbImageFile: node.data.hwbImageFile,
          goodsImageFile: node.data.goodsImageFile,
          processCustoms: node.data.processCustoms,
          updtime: node.data.updtime,
          gcidate: node.data.gcidate,
          remark: node.data.remark,
          goodsType: node.data.goodsType,
          declPiece: node.data.declPiece,
          goodsDesc: node.data.goodsDesc,
        };
        dispatch(setLoadingRedux(false));
        return rowDataCRUD.push(itemDataCRUD);
      });
    } else {
      dispatch(setLoadingRedux(false));
      enqueueSnackbar('請先選擇資料');
      return;
    }
    const DataCRUD: ICRUD = {
      tmpStorageGoodsMtnGoodsPositions: rowDataCRUD,
      warehouse: master.warehouse,
      hawbNo: master.hawbNo,
      storageAreaId: master.storageAreaId,
      processCustoms: master.processCustoms,
      expresssId: master.chkCode1,
      goodsType: master.goodsType,
      defMawbNo: master.defMawbNo,
      releaseDateIsNull: master.releaseDateIsNull,
    };

    const result = await confirm(apiName, DataCRUD);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;

    const {
      enableSave: enableSaveTemp,
      tmpStorageGoodsMtnGoodsPositions: rowDetailsTemp,
    } =
      (dataTemp as {
        enableSave: boolean;
        tmpStorageGoodsMtnGoodsPositions: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(false);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const result = await postExcel(apiName, {
        warehouse: master.warehouse,
        goodsType: master.goodsType,
        storageAreaId: master.storageAreaId,
        hawbNo: master.hawbNo,
        processCustoms: master.processCustoms,
        expresssId: master.chkCode1,
        defMawbNo: master.defMawbNo,
        releaseDateIsNull: master.releaseDateIsNull,
        startUpdtime:
          master.timeCheck === '1'
            ? master.startUpdtime + master.startTime
            : '',
        endUpdtime:
          master.timeCheck === '1' ? master.endUpdtime + master.endTime : '',
      });

      blobDownload(
        result,
        enqueueSnackbar,
        `${formatDate(getDateDayPlus(), 'yyyyMMddHHmmss')}_${
          master.warehouse
        }_暫存貨物查詢_${user.name}.xlsx`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));

    await gridRef.current.api.stopEditing(false);

    const rowDataCRUD: ICRUDDetail[] = [];

    const selectedDatas = gridRef.current.api.getSelectedNodes();
    if (selectedDatas && selectedDatas.length > 0) {
      selectedDatas.forEach((node: any) => {
        const itemDataCRUD: ICRUDDetail = {
          rownum: node.data.rownum,
          storageAreaId: node.data.storageAreaId,
          warehouse: node.data.warehouse,
          storageAreaDesc: node.data.storageAreaDesc,
          locationDesc: node.data.locationDesc,
          hawbNo: node.data.hawbNo,
          mawbNo: node.data.mawbNo,
          lastdeclNo: node.data.lastdeclNo,
          expressCnam: node.data.expressCnam,
          boxNo: node.data.boxNo,
          storagePiece: node.data.storagePiece,
          length: node.data.length,
          width: node.data.width,
          height: node.data.height,
          volume: node.data.volume,
          weight: node.data.weight,
          releaseDateDesc: node.data.releaseDateDesc,
          hwbImageFile: node.data.hwbImageFile,
          goodsImageFile: node.data.goodsImageFile,
          processCustoms: node.data.processCustoms,
          updtime: node.data.updtime,
          gcidate: node.data.gcidate,
          remark: node.data.remark,
          goodsType: node.data.goodsType,
          declPiece: node.data.declPiece,
          goodsDesc: node.data.goodsDesc,
        };
        dispatch(setLoadingRedux(false));
        return rowDataCRUD.push(itemDataCRUD);
      });
    } else {
      dispatch(setLoadingRedux(false));
      enqueueSnackbar('請先選擇資料');
      return;
    }
    const DataCRUD: ICRUD = {
      tmpStorageGoodsMtnGoodsPositions: rowDataCRUD,
      warehouse: master.warehouse,
      hawbNo: master.hawbNo,
      storageAreaId: master.storageAreaId,
      processCustoms: master.processCustoms,
      expresssId: master.chkCode1,
      goodsType: master.goodsType,
      defMawbNo: master.defMawbNo,
      releaseDateIsNull: master.releaseDateIsNull,
    };

    const result = await deleteItem(apiName, DataCRUD);

    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;

    const {
      enableSave: enableSaveTemp,
      tmpStorageGoodsMtnGoodsPositions: rowDetailsTemp,
    } =
      (dataTemp as {
        enableSave: boolean;
        tmpStorageGoodsMtnGoodsPositions: unknown | unknown[];
      }) || {};
    const data = rowDetailsTemp as Iresult[];

    if ((data || []).length > 0) {
      setEnableSave(false);

      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setEnableSave(false);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'confirm':
        handleConfirm();
        break;
      case 'getExcel':
        handleDownload();
        break;
      case 'deleteItem':
        handleDeleteItem();
        break;

      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);

    // console.log(key[0]);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        for (index = index3; index < index2; index += 1) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setEnableSave(false);
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 暫存貨物查詢
          </div>
        </div>
        <div className="input-area">
          {userType &&
            (isType(userTypeList.admin, userType) ||
              isType(userTypeList.topType, userType) ||
              isType(userTypeList.type4, userType) ||
              isType(userTypeList.type2, userType) ||
              isTypeBK(userType)) && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  <FormTitle>
                    {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                      userType
                    ) !== -1
                      ? '*'
                      : ''}
                    快遞倉站：
                  </FormTitle>
                </VcEGrid>
                <VcGrid item xs={12} sm={3}>
                  <WarehouseModal
                    value={master.warehouse}
                    updateData={updateData}
                    setStatus={setWarehouseName}
                  />
                </VcGrid>

                <VcGrid item xs={12} sm={3}>
                  {warehouseName && (
                    <Alert
                      severity="info"
                      style={{
                        width: '100%',
                        color: 'red',
                        margin: '0 0.5rem',
                        fontSize: '1em',
                      }}
                      icon={false}
                    >
                      {warehouseName}
                    </Alert>
                  )}
                </VcGrid>
              </Grid>
            )}
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>分號：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.hawbNo}
                name="hawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>儲區：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.storageAreaId}
                onChange={selectChange(updateData)}
                name="storageAreaId"
                options={storageAreaOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>分類：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.goodsType}
                onChange={selectChange(updateData)}
                name="goodsType"
                options={goodsTypeOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>承辦關員：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={2}>
              <Input
                maxLength={35}
                value={master.processCustoms}
                name="processCustoms"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>快遞/承攬業者：</FormTitle>
            </VcEGrid>

            <VcGrid item xs={12} sm={3}>
              <Input
                name="chkCode1"
                disabled={userTypeList.type2.indexOf(userType) !== -1}
                maxLength={4}
                value={master.chkCode1}
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>入儲時間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={4} style={{ maxWidth: 800 }}>
              <DateSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={['startUpdtime', 'endUpdtime']}
                data={master}
                seInterval={31}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入入儲時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startUpdtime: masterDefaultValue.startUpdtime,
                    endUpdtime: masterDefaultValue.endUpdtime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text" />
            <Grid item xs={12} sm={2}>
              <CheckBox
                label="預設主號"
                disabled={userTypeList.type2.indexOf(userType) !== -1}
                checked={master.defMawbNo === true}
                name="defMawbNo"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    ...checkboxChange()([true, false])(e),
                  }));
                }}
              />
            </Grid>
            <VcEGrid item xs={12} sm={1} className="input-text" />
            <Grid item xs={12} sm={2}>
              <CheckBox
                label="放行日期為空值"
                disabled={userTypeList.type2.indexOf(userType) !== -1}
                checked={master.releaseDateIsNull === true}
                name="releaseDateIsNull"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    ...checkboxChange()([true, false])(e),
                  }));
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => setSubmitKey('confirm')}
            >
              確定
            </Button>
          </VcEGrid>

          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('getExcel')}
            >
              下載Excel
            </Button>
          </Grid>

          <VcEGrid item xs={12} sm="auto">
            <Button
              disabled={!enableSave || formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<DeleteForeverIcon />}
              onClick={() => setSubmitKey('deleteItem')}
            >
              刪除
            </Button>
          </VcEGrid>
        </Grid>
      </form>

      {openSearchTable && (
        <Grid container>
          <VcEGrid>
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectPage}
              variant="contained"
              color="default"
              startIcon={
                <DoneAllIcon
                  style={{
                    borderRadius: '30px',
                  }}
                />
              }
            >
              全選
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              className="button-DutyNoQryDld"
              type="submit"
              onClick={selectNoPage}
              variant="contained"
              color="default"
              startIcon={<ClearIcon />}
            >
              全不選
            </Button>
          </Grid>
        </Grid>
      )}
      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default TmpStorageGoodsMtn;
